import React, { useState } from 'react';
import { Card, Button } from './ui';
import { ShieldCheck, Plus, Minus, Scale, Clock, Lock, Zap, CreditCard } from 'lucide-react';
const CHECKOUT_URL = 'https://cachorro-sin-crisis.impultienda.ar/checkout';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-188" data-mp="2wkmpqfualstu">
      <div className="max-w-3xl mx-auto" data-id="element-189" data-mp="2wloajc141tor">
        <Card className="bg-gradient-to-br from-slate-900 to-slate-800 border-emerald-500/30 text-center relative overflow-hidden" data-id="element-190" data-mp="2wmqypc71ti0z">
          <div className="absolute -right-10 -top-10 text-emerald-500/10" data-id="element-191" data-mp="3p8sa31hfpft5">
            <ShieldCheck className="w-64 h-64" data-id="element-192" data-mp="3kilnf76hg5dj" />
          </div>
          <div className="relative z-10" data-id="element-193" data-mp="3kh0tnjrzsqgq">
            <ShieldCheck className="w-16 h-16 text-emerald-400 mx-auto mb-6" data-id="element-194" data-mp="3fjikbsa2c987" />
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-195" data-mp="3fheciz91mq2n">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>
            <p className="text-xl text-slate-300 mb-6" data-id="element-196" data-mp="c31wwfx75126">
              Abrís los tomos. Los aplicás junto a tu cachorro.
            </p>
            <p className="text-lg text-slate-400 mb-8" data-id="element-197" data-mp="2hkmg52ay69wz">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-198" data-mp="2lkeu5uj4189q" />
              <strong className="text-white" data-id="element-199" data-mp="2ln0yzmem99o9">devolución del 100%</strong>
              <br data-id="element-200" data-mp="27sqfpkle27pl" />
              sin formularios, sin drama.
            </p>
            <p className="text-sm text-emerald-400/80 font-medium" data-id="element-201" data-mp="2crtc6gnaz5ly">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Sirve para cualquier raza?',
    a: 'Sí. El kit está pensado para acompañar las necesidades esenciales de cachorros de cualquier raza. Podés adaptar cada rutina a su tamaño, energía y etapa de crecimiento.'
  }, {
    q: '¿Y si tiene solo 2 meses?',
    a: 'Sí, es un gran momento para empezar. Encontrarás pautas suaves y claras para las primeras rutinas, la adaptación al hogar y el aprendizaje desde cero.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital en PDF. Después de completar el pago recibís un email automático con el enlace de descarga en menos de 5 minutos. Podés verlo en el celular, la tablet o imprimirlo en casa.'
  }, {
    q: '¿Necesito experiencia?',
    a: 'No. Todo está explicado paso a paso, con propuestas simples para aplicar desde el primer día, aunque sea tu primer cachorro.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 7 días completos sin preguntas. Si no estás satisfecho por cualquier motivo escribís a supportpuntodigital@gmail.com y te devolvemos el 100% del pago.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-202" data-mp="3qszikcrzara9">
      <div className="max-w-3xl mx-auto" data-id="element-203" data-mp="s27jlsjuc59a">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8 flex items-center justify-center gap-3" data-id="element-204" data-mp="s2zet29j00z1">
          <span className="text-brand-400" data-id="element-205" data-mp="na65s270y6h5">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-206" data-mp="uo6vrjypunzy">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-800 rounded-xl bg-slate-900 overflow-hidden" data-id="element-207" data-mp="zmrutg28f1mt" data-mpi={i}>
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(open === i ? null : i)} data-id="element-208" data-mp="14mwdncqm48g7">
                <span className="font-bold text-white pr-8" data-id="element-209" data-mp="1djne01c769gl">{faq.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-brand-400 shrink-0" data-id="element-210" data-mp="1nbb0dntwd0b7" /> : <Plus className="w-5 h-5 text-slate-500 shrink-0" data-id="element-211" data-mp="1sae8jh56bmne" />}
              </button>
              {open === i && <div className="px-6 pb-4 text-slate-400" data-id="element-212" data-mp="1xaidc9wpysxs">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function CostOfInaction() {
  return <section className="py-12 px-4" data-id="element-213" data-mp="2yyx9a3y8x2aw">
      <div className="max-w-4xl mx-auto" data-id="element-214" data-mp="2yxujy0gkn7x3">
        <div className="text-center mb-8" data-id="element-215" data-mp="2u1nlstuf30pp">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-216" data-mp="2u0lynr04mnrm">
            <Scale className="w-9 h-9 text-amber-400" data-id="element-217" data-mp="37u3h18h2tug2" /> ¿CUÁNTO CUESTA NO
            TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-218" data-mp="2g0t7jukou5j4">
          <table className="w-full text-left border-collapse bg-slate-900 rounded-xl overflow-hidden" data-id="element-219" data-mp="2g1mi76mrpf6j">
            <thead data-id="element-220" data-mp="2b3ugxm08ggpo">
              <tr className="border-b border-slate-800 bg-slate-800/50" data-id="element-221" data-mp="2b4cld5x1u18o">
                <th className="p-4 text-slate-300 font-medium" data-id="element-222" data-mp="2p3c828104627">
                  Sin una guía clara
                </th>
                <th className="p-4 text-red-400 font-bold" data-id="element-223" data-mp="2k510y523c9no">Costo real</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800" data-id="element-224" data-mp="3vhv5fafw5xxp">
              <tr data-id="element-225" data-mp="3vhbkrlyuwvfz">
                <td className="p-4 text-slate-400" data-id="element-226" data-mp="3vjxqdg26t0vk">
                  Accidentes de pis repetidos durante las primeras semanas
                </td>
                <td className="p-4 text-white font-medium" data-id="element-227" data-mp="bvbby9pm1k5z">
                  Limpieza, frustración y hábitos más difíciles de corregir
                </td>
              </tr>
              <tr data-id="element-228" data-mp="2ud2hbwekkg0">
                <td className="p-4 text-slate-400" data-id="element-229" data-mp="2tl987qa2ysw">
                  Noches interrumpidas y una rutina sin orden
                </td>
                <td className="p-4 text-white font-medium" data-id="element-230" data-mp="qkh8fpx2cwa6">
                  Descanso de toda la familia afectado
                </td>
              </tr>
              <tr data-id="element-231" data-mp="gunyetckkp81">
                <td className="p-4 text-slate-400" data-id="element-232" data-mp="gt4hr1n04c5q">
                  Mordidas y destrozos por aburrimiento o ansiedad
                </td>
                <td className="p-4 text-white font-medium" data-id="element-233" data-mp="lr5znj8oy5fm">
                  Objetos dañados y más estrés en casa
                </td>
              </tr>
              <tr data-id="element-234" data-mp="1e9tist44nae2">
                <td className="p-4 text-slate-400" data-id="element-235" data-mp="1eabi5ym364q7">
                  Consejos contradictorios sin una estrategia
                </td>
                <td className="p-4 text-white font-medium" data-id="element-236" data-mp="1o360p4s4ah17">
                  Tiempo perdido y avances que no se sostienen
                </td>
              </tr>
              <tr data-id="element-237" data-mp="1e61g39dx6tmi">
                <td className="p-4 text-slate-400" data-id="element-238" data-mp="1e5jb9od6z72z">
                  Reaccionar tarde ante señales de salud importantes
                </td>
                <td className="p-4 text-white font-medium" data-id="element-239" data-mp="15767jqnel7g1">
                  Preocupación innecesaria y decisiones bajo presión
                </td>
              </tr>
              <tr data-id="element-240" data-mp="10e4nz5c94jq4">
                <td className="p-4 text-slate-400" data-id="element-241" data-mp="vglai7ndoaz8">
                  Una familia frustrada en vez de disfrutar sus primeros meses
                </td>
                <td className="p-4 text-white font-medium" data-id="element-242" data-mp="qjct49a20az1">
                  Menos calma, vínculo y bienestar compartido
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-243" data-mp="hhvbgmh00188">
          <h3 className="text-2xl font-bold text-brand-400 mb-4" data-id="element-244" data-mp="2t3dptgxcfyoz">
            Hoy quizás tu mayor problema sea el pis, las mordidas o las noches
            sin dormir.
          </h3>
          <blockquote className="text-xl text-slate-300 italic border-l-4 border-brand-500 pl-6 py-2 text-left" data-id="element-245" data-mp="324lpo3fid7l6">
            "No importa cuál sea: dentro de este Kit vas a encontrar un método
            específico para resolver cada uno de esos desafíos. Empezá hoy y
            evitá meses de prueba y error."
          </blockquote>
        </div>

        {/* Final CTA Block */}
        <Card glow className="bg-slate-900 border-brand-500/50 text-center" data-id="element-246" data-mp="2jelztebufogp">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 border border-red-500/20 px-4 py-2 rounded-full font-bold mb-8" data-id="element-247" data-mp="2jcj5ii3nr966">
            <Clock className="w-5 h-5" data-id="element-248" data-mp="1qqq52f5u46mk" />
            EL PRECIO CIERRA EN: 23 hs : 59 min : 52 seg
          </div>

          <div className="grid md:grid-cols-1 gap-6 mb-8 max-w-md mx-auto" data-id="element-249" data-mp="1vnqdgwq5plgu">
            <div className="p-6 border border-slate-700 rounded-xl bg-slate-800/50" data-id="element-250" data-mp="p0xh9hds9qqe">
              <h4 className="font-bold text-white mb-2" data-id="element-251" data-mp="k2w0x47qs5im">
                PUNTO DIGITAL™ — KIT PARA CACHORRO
              </h4>
              <p className="text-sm text-slate-400 mb-4" data-id="element-252" data-mp="y3gf1n2ppd5s">
                6 Tomos + 5 Bonos · Un comienzo más tranquilo
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-253" data-mp="u2wm6vp68vpg">
                <span className="text-slate-500 line-through text-sm" data-id="element-254" data-mp="17z0cidwxcjwn">
                  49990
                </span>
                <span className="text-3xl font-black text-white" data-id="element-255" data-mp="12zdxbyxjctl7">$19.990</span>
                <span className="text-sm text-slate-400" data-id="element-256" data-mp="1hpuzxllwppjo">ARS</span>
              </div>
              <Button className="w-full" variant="outline" onClick={() => {
              window.location.href = CHECKOUT_URL;
            }} data-id="element-257" data-mp="1csmffedad9f9">
                → QUIERO MI KIT PARA CACHORRO
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400" data-id="element-258" data-mp="25eb3yoyyq3ic">
            <span className="flex items-center" data-id="element-259" data-mp="2abjnotzreflp">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-260" data-mp="1wd3capqyc0x8" /> Pago 100% seguro
            </span>
            <span className="flex items-center" data-id="element-261" data-mp="20eomu4g0k349">
              <Zap className="w-4 h-4 mr-1 text-amber-400" data-id="element-262" data-mp="20ddia2equrc3" /> Acceso en 5
              minutos
            </span>
            <span className="flex items-center" data-id="element-263" data-mp="1mlz0fywkow6m">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-400" data-id="element-264" data-mp="1reiesy333vch" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-265" data-mp="1cq5g3tcm3yea">
              <CreditCard className="w-4 h-4 mr-1 text-blue-400" data-id="element-266" data-mp="1cn9ftydakxmo" /> Mercado Pago
              | Tarjeta | Transferencia
            </span>
          </div>
        </Card>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-slate-950 py-10 px-4 border-t border-slate-900" data-id="element-267" data-mp="18o0qr6t75nxg">
      <div className="max-w-4xl mx-auto text-center" data-id="element-268" data-mp="349zxkloaz70s">
        <div className="inline-flex items-center gap-2 mb-6" data-id="element-269" data-mp="348ggisutorxy">
          <span className="text-brand-400 font-bold tracking-widest uppercase" data-id="element-270" data-mp="399mcczjs4vbp">
            PUNTO DIGITAL™
          </span>
        </div>

        <p className="text-slate-400 mb-4 max-w-2xl mx-auto" data-id="element-271" data-mp="2vawevit1stmt">
          El kit de educación y bienestar para familias argentinas que quieren
          criar a su cachorro con más calma, criterio y confianza.
        </p>
        <p className="text-slate-500 mb-8 italic" data-id="element-272" data-mp="3o03kf1qx6jhk">
          Porque sus primeros meses merecen una guía que acompañe a toda la
          familia.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-slate-400 mb-12" data-id="element-273" data-mp="3e74o0xp6lone">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-brand-400 transition-colors" data-id="element-274" data-mp="3j5fwb3ztvr3i">
            supportpuntodigital@gmail.com
          </a>
          <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-275" data-mp="fji8pd6wlcar">
            www.puntodigital.store
          </a>
        </div>

        <div className="text-xs text-slate-600 space-y-2" data-id="element-276" data-mp="kvnnv1htj3ky">
          <p data-id="element-277" data-mp="kv5jtiowzl2h">© Punto Digital™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-278" data-mp="ylr5tg9o0b4l">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-900" data-id="element-279" data-mp="to91y4ai8m3g">
          <p className="text-brand-500/50 font-medium italic" data-id="element-280" data-mp="5xd68w2xh6qx">
            "Esta semana puede ser diferente."
          </p>
          <p className="text-slate-500 text-sm mt-2" data-id="element-281" data-mp="1xutwop6a3zp">
            "Un cachorro feliz empieza con una familia acompañada."
          </p>
        </div>
      </div>
    </footer>;
}